import Vue from "vue";
import VueRouter from "vue-router";

//页面
import login from "./pages/login";
import info from "./pages/info";
import empty from "./pages/empty";


Vue.use(VueRouter);

const routes = [
    {
        path:"/login",
        component: login
    },
    {
        path:"/info",
        component: info
    },
    {
        path:"/empty",
        component: empty
    },
    {
        path:"/",
        component: login
    }
]

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone", "iPad", "iPod"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
      }
  }
  return flag;
}

var router =  new VueRouter({
    routes
})
router.beforeResolve((to, from, next)=>{

  if(!IsPC()&&to.path!='/empty'){
    next({
      path: '/empty',
      query:{
        shid: to.query.shid
      }
    })
  } else if(IsPC()&&to.path=='/empty') {
    next({
      path: '/info',
      query:{
        shid: to.query.shid
      }
    });
  } else {
    next();
  }
})
export default router;